/**
 * Environment configuration for OAuth and API endpoints.
 */

export interface EnvironmentConfig {
  google: {
    clientId: string;
    loginUrl: string;
    redirectUrl: string;
    tokenInfoUrl: string;
  };
}

const environment: EnvironmentConfig = {
  google: {
    clientId: '609111530408-86nk3prnstenk0pltg7h9uqkaft9m3h6.apps.googleusercontent.com',
    loginUrl: 'https://accounts.google.com/o/oauth2/v2/auth',
    redirectUrl: window.location.origin,
    tokenInfoUrl: 'https://oauth2.googleapis.com/tokeninfo'
  }
};

export default environment;
